'use strict';

const isInViewport = (element, fullyInView) => {
    if (!element) {
        return false;
    }
    const pageTop = $(window).scrollTop();
    const pageBottom = pageTop + $(window).height();
    const elementTop = $(element).offset().top;
    const elementBottom = elementTop + $(element).height();
    const pageLeft = $(window).scrollLeft();
    const pageRight = pageLeft + $(window).width();
    const elementLeft = $(element).offset().left;
    const elementRight = elementLeft + $(element).width();

    if (fullyInView === true) {
        return ((pageTop < elementTop) && (pageBottom > elementBottom) && (pageLeft < elementLeft) && (pageRight > elementRight));
    } else {
        return ((elementTop <= pageBottom) && (elementBottom >= pageTop) && (elementLeft <= pageRight) && (elementRight >= pageLeft));
    }
};

module.exports = isInViewport;
